<template>
  <div class="page">
    <div class="page-main">
      <header-comp></header-comp>
      <nav-bar></nav-bar>
      
      <div class="my-3 my-md-5">
        <router-view></router-view>
      </div>
    </div>

    <footer-comp></footer-comp>
  </div>
</template>

<style lang="css">
  @import '~src/assets/css/dashboard.css';
  @import '~src/assets/css/styles.css';
  @import '~src/assets/css/calendar.css';
</style>

<script>
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import Header from '../components/Header'

export default {
  components: {
    'nav-bar': NavBar,
    'footer-comp': Footer,
    'header-comp': Header
  },
  created() {
    var self = this;
  }
};
</script>



// WEBPACK FOOTER //
// DashView.vue?58c2a53c